import {Routes} from '@angular/router';
import {rechteResolver} from './core/resolver/rechte.resolver';
import {ordnerResolver} from './core/resolver/ordner.resolver';
import {PostfachComponent} from './postfach/postfach.component';
import {OiamService} from './core/services/apiservices/oiam.service';
import {AccessDeniedComponent} from "./core/components/access-denied/access-denied.component";
import {ErrorComponent} from "./core/components/error/error.component";
import {NachrichtAnzeigenComponent} from "./nachricht-anzeigen/nachricht-anzeigen.component";
import {entwurfResolver, nachrichtenResolver} from "./core/resolver/nachrichten.resolver";
import {dienststellenAnliegenMapResolver} from "./core/resolver/dienststellen-anliegen-map.resolver";
import {NachrichtNeuComponent} from "./nachricht-schreiben/nachricht-neu/nachricht-neu.component";
import {NachrichtAntwortenComponent} from "./nachricht-schreiben/nachricht-antworten/nachricht-antworten.component";
import {
    NachrichtEntwurfComponent
} from "./nachricht-schreiben/nachricht-entwurf/nachricht-entwurf.component";
import {KeinOnlineZugriffComponent} from "./nachricht-schreiben/kein-online-zugriff/kein-online-zugriff.component";
import {TestComponent} from "./test/test/test.component";
import {APP_ROUTES} from "./route-constants";
import {DeeplinkGuard} from "./core/guards/deeplink.guard";
import {
    NachrichtNeuVorbelegtComponent
} from "./nachricht-schreiben/nachricht-neu-vorbelegt/nachricht-neu-vorbelegt.component";
import {redirectGuard} from "./core/guards/redirect.guard";
import {NachrichtSuccessComponent} from "./nachricht-schreiben/nachricht-success/nachricht-success.component";
import { ForbiddenBetriebePage } from './core/components/forbidden-betriebe/forbidden-betriebe.page';
import { NotFoundPage } from './core/components/not-found/not-found.page';
import { environment } from '../environments/environment';

export const routes: Routes = [
    {
        path: APP_ROUTES.ACCESS_DENIED,
        component: AccessDeniedComponent
    },
    {
        path: APP_ROUTES.FORBIDDEN_BETRIEBE,
        component: ForbiddenBetriebePage
    },
    {
        path: APP_ROUTES.ERROR,
        component: ErrorComponent
    },
    {
        path: APP_ROUTES.ORDNER,
        component: PostfachComponent,
        canActivate: [OiamService.canActivate],
        resolve: {
            combined: ordnerResolver,
        },
        title: 'Nachrichten',
    },
    {
        path: APP_ROUTES.NACHRICHT_ANZEIGEN,
        component: NachrichtAnzeigenComponent,
        canActivate: [OiamService.canActivate, redirectGuard],
        resolve: {
            benutzerRechte: rechteResolver,
            nachricht: nachrichtenResolver,
        },
        title: 'Nachricht anzeigen',
    },
    {
        path: APP_ROUTES.NEU,
        component: NachrichtNeuComponent,
        resolve: {
            benutzerRechte: rechteResolver,
            anliegenUndDienststellen: dienststellenAnliegenMapResolver,
        },
        canActivate: [OiamService.canActivate, redirectGuard],
        title: 'Nachricht schreiben',
    },
    {
        path: APP_ROUTES.NEU_VORBELEGT,
        component: NachrichtNeuVorbelegtComponent,
        resolve: {
            benutzerRechte: rechteResolver,
            anliegenUndDienststellen: dienststellenAnliegenMapResolver,
        },
        canActivate: [OiamService.canActivate, redirectGuard],
        title: 'Nachricht schreiben',
    },
    {
        path: APP_ROUTES.ANTWORT,
        component: NachrichtAntwortenComponent,
        resolve: {
            benutzerRechte: rechteResolver,
            vorgaenger: nachrichtenResolver,
        },
        canActivate: [OiamService.canActivate, redirectGuard],
        title: 'Nachricht schreiben',
    },
    {
        path: APP_ROUTES.ENTWURF,
        component: NachrichtEntwurfComponent,
        resolve: {
            benutzerRechte: rechteResolver,
            entwurf: entwurfResolver,
        },
        canActivate: [OiamService.canActivate, redirectGuard],
        title: 'Nachricht schreiben',
    },
    {
        path: APP_ROUTES.SUCCESS,
        component: NachrichtSuccessComponent,
        canActivate: [OiamService.canActivate, redirectGuard],
        title: 'Nachricht gesendet',
    },
    {
        path: APP_ROUTES.KEIN_ONLINE_ZUGRIFF,
        component: KeinOnlineZugriffComponent,
        resolve: {
            benutzerRechte: rechteResolver
        },
        title: 'Nachricht schreiben - kein online Zugriff',
    },
    {
        path: APP_ROUTES.NOT_FOUND,
        component: NotFoundPage,
        title: 'Seite nicht gefunden',
    },
];

if (!environment.production) {
    routes.push({
        path: 'testit',
        component: TestComponent,
        canActivate: [OiamService.canActivate],
        resolve: {
            combined: ordnerResolver,
        },
        title: 'Testseite',
    },);
}

routes.push({
        path: '**',
        canActivate: [DeeplinkGuard],
        component: NotFoundPage,
})